import React, { useMemo } from 'react';

import {
  Row,
  Col,
  Button
} from 'reactstrap';

import FieldError from '../../../../../../helper/FieldError';

import WorkflowHttpRequestBodyResponseContentItemForm from './item_form';

const WorkflowHttpRequestBodyResponseList = props => {

  const {
    currentNode,
    callbacks: {
      onAddBodyResponseContentItem: callbackOnAddBodyResponseContentItem,
      onChangeBodyResponseContentItem: onChangeBodyResponseContentItem,
      onRemoveBodyResponseContentItem: callbackOnRemoveBodyResponseContentItem,
      activeOutputStageFileItems,

    }
  } = props;

  const bodyResponseContent = useMemo(() => {
    return currentNode?.data?.body_response_content || [];
  }, [currentNode?.data?.body_response_content])

  return (
    <Row>
      <Col md={ 12 }>
        <FieldError errors={ _.get(currentNode, 'data.errors.body_response_content') }/>
        { _.map(bodyResponseContent, (bodyResponseContentItem) => {
          return (
            <WorkflowHttpRequestBodyResponseContentItemForm
              key={ `WorkflowHttpRequestBodyResponseContentItemForm-${ bodyResponseContentItem?.custom_id }` }
              currentNode={ currentNode }
              bodyResponseContentItem={ bodyResponseContentItem }
              callbacks={{
                onChangeBodyResponseContentItem: onChangeBodyResponseContentItem,
                onRemoveBodyResponseContentItem: callbackOnRemoveBodyResponseContentItem,
                activeOutputStageFileItems: activeOutputStageFileItems
              }}
            />
          )
        })}
        <div className='text-center'>
          <Button
            outline
            color='success'
            size="sm"
            onClick={ callbackOnAddBodyResponseContentItem }
          >
            Add Body Response Content Item
          </Button>
        </div>
      </Col>
    </Row>
  )
}

export default WorkflowHttpRequestBodyResponseList;
